(function(angular){
	'use strict';

	angular
		.module('apiModule')
		.factory('TransactionsFactory', [
			'$filter',
			'$q',
			'INVESTMENT_ENTITY_ID',
			'urlFactory',
			transactionServiceFunction
		]);

	function transactionServiceFunction(
		$filter,
		$q,
		INVESTMENT_ENTITY_ID,
		urlFactory
	) {
				
		var factory = {
			getTransactions: getTransactions,
			cancelTransaction: cancelTransaction,
			cancelRedemptionRequestTransaction: cancelRedemptionRequestTransaction
		};

		return factory;

		function getTransactions() {
			var completeTransactionsPromise = getTransactionsByStatus({status: 'COMPLETE'});
			var incompleteTransactionsPromise = getTransactionsByStatus({status: 'PENDING'});

			return $q.all({
				completeTransactions: completeTransactionsPromise,
				incompleteTransactions: incompleteTransactionsPromise
			}).then(function(response) {
				return response;
			}).catch(function(response) {
				urlFactory.handleFailedRequest(response);
			});
		}

		function cancelTransaction(transactionData) {
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/investment/order-group/' + transactionData.reitInvestmentOrderGroupId + '/cancel-order';
			return urlFactory.apiPutPromise(url, {reitInvestmentOrderGroupVersion:transactionData.reitInvestmentOrderGroupVersion})
				.then(function() {
					return '/account/' + transactionData.reitInvestmentOrderGroupId + '/' + transactionData.cancelType + '/success';
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function cancelRedemptionRequestTransaction(redemptionRequestId, type) {
			var url = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/redemption-request/' + redemptionRequestId + '/cancel-request';
			if (type === 'REDEMPTION_REQUEST_GROUP') {
				url += '-group';
			}
			return urlFactory.apiPutPromise(url, {redemptionRequestId:redemptionRequestId})
				.then(function() {
					return '/account/cancel-redemption-request/' + redemptionRequestId + '/' + type + '/success';
				})
				.catch(function(response) {
					urlFactory.handleFailedRequest(response);
					return $q.reject();
				});
		}

		function getTransactionsByStatus(status) {
			var targetPath = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/transactions';
			
			var transactionsUrl = urlFactory.serializeParamsAndCreateUrl(targetPath, status);
			return urlFactory.apiGetPromise(transactionsUrl)
				.then(function(response) {
					return formatTransactionList(response.data.data);
				});
		}
		
		function formatTransactionList(rawTransactionsData){
			var transactions = [];
			angular.forEach(rawTransactionsData, function(rawTransaction) {
				if (rawTransaction.type === 'DIVIDEND') {
					transactions.push(formatDividendTransaction(rawTransaction));
				} else if (rawTransaction.type === 'INVESTMENT' || rawTransaction.type === 'AUTO_INVEST' || rawTransaction.type === 'DIVIDEND_REINVESTMENT') {
					transactions.push(formatInvestmentTransaction(rawTransaction));
				} else if (rawTransaction.type === 'REDEMPTION') {
					transactions.push(formatRedemptionTransaction(rawTransaction));
				} else if (rawTransaction.type === 'REDEMPTION_REQUEST' || rawTransaction.type === 'REDEMPTION_REQUEST_GROUP') {
					transactions.push(formatRedemptionRequestTransaction(rawTransaction));
				} else if (rawTransaction.type === 'TRANSFER') {
					transactions.push(formatTransferTransaction(rawTransaction));
				}
			});
			
			return transactions;
		}
		
		function formatDividendTransaction(rawTransaction) {
			var reitTableData = rawTransaction.transactionDetails.transactionDetailsReitTable;
			var includesWithholdings = false;
			
			for (var i = 0; i < reitTableData.data.length; i++) {
				if (reitTableData.data[i].stateDividendWithholdings > 0) {
					includesWithholdings = true;
					break;
				}
			}
			
			var reitTable = [];
			angular.forEach(reitTableData.data, function(reit) {
				if (includesWithholdings) {
					reitTable.push([reit.title, 
						formatCurrency(reit.grossDividend), 
						formatCurrency(reit.advisoryFee), 
						formatCurrency(reit.stateDividendWithholdings),
						formatCurrency(reit.netDividend)]);
				} else {
					reitTable.push([reit.title, 
						formatCurrency(reit.grossDividend), 
						formatCurrency(reit.advisoryFee), 
						formatCurrency(reit.netDividend)]);
				}
			});
			
			var totalRow = [];
			if(angular.isDefined(reitTableData.totalRow)) {
				if (includesWithholdings) {
					totalRow = [reitTableData.totalRow.title,
						formatCurrency(reitTableData.totalRow.grossDividend), 
						formatCurrency(reitTableData.totalRow.advisoryFee), 
						formatCurrency(reitTableData.totalRow.stateDividendWithholdings),
						formatCurrency(reitTableData.totalRow.netDividend)];
				} else { 
					totalRow = [reitTableData.totalRow.title,
						formatCurrency(reitTableData.totalRow.grossDividend), 
						formatCurrency(reitTableData.totalRow.advisoryFee), 
						formatCurrency(reitTableData.totalRow.netDividend)];
				}
			}
			
			var transaction = baseTransactionObject(rawTransaction);
			var colHeaders = null;
			
			if (includesWithholdings) {
				colHeaders = ['Name', 'Gross dividend', 'Advisory fee', 'State withholdings', 'Net dividend'];
			} else {
				colHeaders = ['Name', 'Gross dividend', 'Advisory fee', 'Net dividend'];
			}
			
			var dividendTransaction = {
					transactionDetails : {
						data:{
							'Issued Date' : formatDate(rawTransaction.transactionDetails.overview.issuedDate)
						},
						transactionDetailsReitTable : {
							headers : colHeaders,
							data : reitTable,
							totalRow : totalRow
						}
					}	
			};
			
			return angular.merge(transaction, dividendTransaction);
		}
		
		function formatInvestmentTransaction(rawTransaction){
			var reitTableData = rawTransaction.transactionDetails.transactionDetailsReitTable;
			
			var reitTable = [];
			angular.forEach(reitTableData.data, function(reit) {
				reitTable.push([reit.title, 
					reit.shares ? reit.shares : 'Awaiting Shares',
					reit.pricePerShare ? formatCurrency(reit.pricePerShare) : 'Awaiting Price',
					formatCurrency(reit.amount)]);
			});
			
			var totalRow = [];
			if (angular.isDefined(reitTableData.totalRow)) {
				totalRow = [reitTableData.totalRow.title,
					reitTableData.totalRow.shares, 
					formatCurrency(reitTableData.totalRow.pricePerShare), 
					formatCurrency(reitTableData.totalRow.amount)];
			}
			
			var transaction = baseTransactionObject(rawTransaction);
			var investmentTransaction = {
					transactionDetails : {
						data:{},
						transactionDetailsReitTable : {
							headers : ['Name', 'Quantity', 'Price', 'Amount'],
							data : reitTable,
							totalRow : totalRow
						}
					}
			};

			if (rawTransaction.type === 'DIVIDEND_REINVESTMENT') {
				investmentTransaction.transactionDetails.data.Source = rawTransaction.transactionDetails.overview.source;
			} else {
				investmentTransaction.transactionDetails.data['Order #'] = rawTransaction.transactionDetails.overview.orderNumber;
				investmentTransaction.transactionDetails.data = angular.merge(investmentTransaction.transactionDetails.data, getPaymentMethod(rawTransaction));
				if (angular.isDefined(rawTransaction.date)){
					investmentTransaction.transactionDetails.data['Order placed'] = formatDate(rawTransaction.date);
				}
				if (angular.isDefined(rawTransaction.transactionDetails.overview.orderComplete)){
					investmentTransaction.transactionDetails.data['Order complete'] = formatDate(rawTransaction.transactionDetails.overview.orderComplete);
				}
				if (angular.isDefined(rawTransaction.expectedSettlementDate)) {
					investmentTransaction.expectedSettlementDate = rawTransaction.expectedSettlementDate;
				}
			}
			
			return angular.merge(transaction, investmentTransaction);
		}
		
		function formatRedemptionTransaction(rawTransaction){
			
			var reitTableData = rawTransaction.transactionDetails.transactionDetailsReitTable;
			
			var reitTable = [];
			angular.forEach(reitTableData.data, function(reit) {
				reitTable.push([reit.title, 
					reit.shares, 
					formatCurrency(reit.pricePerShare),
					formatCurrency(reit.discount), 
					formatCurrency(reit.amount)]);
			});
			
			var totalRow = [];
			if(angular.isDefined(reitTableData.totalRow)) {
				totalRow = [reitTableData.totalRow.title,
					reitTableData.totalRow.shares, 
					formatCurrency(reitTableData.totalRow.pricePerShare), 
					formatCurrency(reitTableData.totalRow.discount), 
					formatCurrency(reitTableData.totalRow.amount)];
			}
			
			var transaction = baseTransactionObject(rawTransaction);
			var redemptionTransaction = {
					transactionDetails : {
						data:{},
						transactionDetailsReitTable : {
							headers : ['Name', 'Quantity', 'Price', 'Discount','Total'],
							data : reitTable,
							totalRow : totalRow
						}
					}	
			};
			redemptionTransaction.transactionDetails.data['Redemption number'] = rawTransaction.transactionDetails.overview.redemptionNumber;
			redemptionTransaction.transactionDetails.data = angular.merge(redemptionTransaction.transactionDetails.data, getPaymentMethod(rawTransaction));
			
			if (angular.isDefined(rawTransaction.transactionDetails.overview.effectiveDate)){
				redemptionTransaction.transactionDetails.data['Effective date'] = formatDate(rawTransaction.transactionDetails.overview.effectiveDate);
			}
			if (angular.isDefined(rawTransaction.transactionDetails.overview.issuedDate)){
				redemptionTransaction.transactionDetails.data['Issued date'] = formatDate(rawTransaction.transactionDetails.overview.effectiveDate);
			}
			
			return angular.merge(transaction, redemptionTransaction);
		}

		function formatRedemptionRequestTransaction(rawTransaction){

			var reitTableData = rawTransaction.transactionDetails.transactionDetailsReitTable;

			var reitTable = [];
			angular.forEach(reitTableData.data, function(reit) {
				reitTable.push([reit.title,
					reit.shares]);
			});

			var totalRow = [];
			if(angular.isDefined(reitTableData.totalRow)) {
				totalRow = [reitTableData.totalRow.title,
					reitTableData.totalRow.shares];
			}

			var transaction = baseTransactionObject(rawTransaction);
			var redemptionRequestTransaction = {
				transactionDetails : {
					data:{},
					transactionDetailsReitTable : {
						headers : ['Name', 'Quantity'],
						data : reitTable,
						totalRow : totalRow
					}
				}
			};

			redemptionRequestTransaction.transactionDetails.data['Redemption #'] = rawTransaction.transactionDetails.overview.orderNumber;
			redemptionRequestTransaction.redemptionRequestId = rawTransaction.transactionDetails.overview.redemptionNumber;
			redemptionRequestTransaction.transactionDetails.data = angular.merge(redemptionRequestTransaction.transactionDetails.data, getPaymentMethod(rawTransaction));

			if (angular.isDefined(rawTransaction.date)){
				redemptionRequestTransaction.transactionDetails.data.Submitted = formatDate(rawTransaction.date);
			}

			if (angular.isDefined(rawTransaction.transactionDetails.overview.effectiveDate)){
				redemptionRequestTransaction.transactionDetails.data.Expected = formatDate(rawTransaction.transactionDetails.overview.effectiveDate);
			}

			if (angular.isDefined(rawTransaction.withdrawalAllowed)) {
				redemptionRequestTransaction.withdrawalAllowed = rawTransaction.withdrawalAllowed;
			}

			return angular.merge(transaction, redemptionRequestTransaction);
		}

		function formatTransferTransaction(rawTransaction){
			
			var transaction = baseTransactionObject(rawTransaction);
			var transferTransaction = {
					transactionDetails : {
						data:{
							'Transfer number' : rawTransaction.transactionDetails.overview.transferNumber,
							'From account' : rawTransaction.transactionDetails.overview.fromAccount,
							'To Account' : rawTransaction.transactionDetails.overview.toAccount,
							'Quantity' : rawTransaction.transactionDetails.overview.sharesTransferred
						}
					}	
			};
			return angular.merge(transaction, transferTransaction);
		}
		
		function baseTransactionObject(rawTransaction){
			var baseObject = {
					type : rawTransaction.type,
					date : rawTransaction.date,
					status : rawTransaction.status,
					amount : rawTransaction.amount,
					title : rawTransaction.title,
					listingName : rawTransaction.listingName
				};
			
			if (angular.isDefined(rawTransaction.cancellableReitInvestmentOrderGroupDto)){
				baseObject.cancellableReitInvestmentOrderGroupDto = rawTransaction.cancellableReitInvestmentOrderGroupDto;
			}
			if (angular.isDefined(rawTransaction.changeBankAccountDto)){
				baseObject.changeBankAccountDto = rawTransaction.changeBankAccountDto;
			}
			return baseObject;
		}

		function getPaymentMethod(rawTransaction){
			var bankAccount = rawTransaction.transactionDetails.overview.bankAccount;
			if (angular.isDefined(bankAccount)){
				var bankAccountWithoutAccountType = bankAccount.replace(/ *\([^)]*\) */g, "");
				return {'Bank account': bankAccountWithoutAccountType  };
			} else if (angular.isDefined(rawTransaction.transactionDetails.overview.iraAccount)){
				return {'IRA account' : rawTransaction.transactionDetails.overview.iraAccount};
			} else if (angular.isDefined(rawTransaction.transactionDetails.overview.paymentMethod)){
				return {'Payment method' : rawTransaction.transactionDetails.overview.paymentMethod};
			}
		}
		
		function formatCurrency(rawCurrency){
			return $filter('currency')(rawCurrency,'$',2); 
		}
		
		function formatDate(rawDate){
			return $filter('date')(rawDate, 'mediumDate');
		}
	}
})(window.angular);